(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  pinForCartDrawer() {
    if (this.cartDrawerPinned) return;
    this.cartDrawerPinned = true;
    this._cartDrawerHadSticky = this.header.classList.contains('shopify-section-header-sticky');
    this._cartDrawerHadHidden = this.header.classList.contains('shopify-section-header-hidden');
    this._cartDrawerHadScrolled = this.header.classList.contains('scrolled-past-header');
    this._cartDrawerHadAnimate = this.header.classList.contains('animate');
    this._cartDrawerPreventReveal = this.preventReveal;
    this.preventReveal = true;
    this.header.classList.add('shopify-section-header-sticky', 'cart-drawer-pinned');
    this.header.classList.remove('shopify-section-header-hidden', 'animate');
    this.setHeaderHeight();
  }
  syncHeaderHeightForCartFly() {
    if (this.header) this.setHeaderHeight();
  }
  unpinForCartDrawer() {
    if (!this.cartDrawerPinned) return;
    this.cartDrawerPinned = false;
    this.preventReveal = this._cartDrawerPreventReveal;
    this.header.classList.remove('cart-drawer-pinned');
    //this.header.classList.toggle('shopify-section-header-sticky', this._cartDrawerHadSticky);
    //this.header.classList.toggle('shopify-section-header-hidden', this._cartDrawerHadHidden);
    //this.header.classList.toggle('scrolled-past-header', this._cartDrawerHadScrolled);
    //this.header.classList.toggle('animate', this._cartDrawerHadAnimate);
  }
  onScroll() {
    if (this.cartDrawerPinned) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hebe-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hebe-product-tabs-specifications')) {
    customElements.define('hebe-product-tabs-specifications', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialise());
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.specificationsController) this.specificationsController.abort();
      }

      initialise() {
        if (!this.isConnected) return;
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('.hptb-tab'));
        this.panels = Array.from(this.querySelectorAll('[data-hpt-panel]'));
        this.items = Array.from(this.querySelectorAll('[data-hpt-item]'));
        this.headings = this.items.map(item => item.querySelector('.hptb-accordion-heading'));
        this.tablist = this.querySelector('[data-hpt-tablist]');
        if (!this.tablist || !this.tabs.length ||
            this.tabs.length !== this.panels.length ||
            this.tabs.length !== this.items.length ||
            this.headings.some(heading => !heading)) return;

        const signal = this.controller.signal;
        this.media = window.matchMedia('(max-width: 749px)');
        this.mode = null;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', event => {
            event.preventDefault();
            this.activate(index, false);
          }, { signal });
          tab.addEventListener('keydown', event => {
            if (this.mode !== 'tabs') return;
            let next = index;
            const rtl = getComputedStyle(this.tablist).direction === 'rtl';
            if (event.key === 'ArrowRight') {
              next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
            } else if (event.key === 'ArrowLeft') {
              next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
            } else if (event.key === 'Home') {
              next = 0;
            } else if (event.key === 'End') {
              next = this.tabs.length - 1;
            } else if (event.key === ' ' || event.key === 'Enter') {
              event.preventDefault();
              this.activate(index, false);
              return;
            } else {
              return;
            }
            event.preventDefault();
            this.activate(next, true);
          }, { signal });
        });

        this.items.forEach((item, index) => {
          item.addEventListener('toggle', () => {
            if (this.mode !== 'accordion') return;
            if (item.open) {
              if (this.dataset.mobileSingleOpen === 'true') {
                this.items.forEach((other, current) => {
                  if (current !== index) other.open = false;
                });
              }
              this.dataset.activeTab = this.tabs[index].dataset.tabKey;
            }
            this.rememberAccordion();
          }, { signal });
        });

        this.media.addEventListener('change', () => this.updateMode(), { signal });
        this.addEventListener('shopify:block:select', event => {
          const blockId = String(event.detail && event.detail.blockId || '');
          const index = this.tabs.findIndex(tab => tab.dataset.blockId === blockId);
          if (index >= 0) this.activate(index, false);
        }, { signal });

        this.updateMode();
        this.classList.add('hptb--ready');
        this.initialiseSpecifications();
      }


      initialiseSpecifications() {
        if (this.specificationsController) this.specificationsController.abort();
        this.specificationRows = Array.from(this.querySelectorAll('[data-hpt-variant-field]'));
        if (!this.specificationRows.length) return;
        this.specificationsCache = new Map();
        this.requestedVariantId = '';
        this.currentVariantId = this.dataset.variantId || '';
        if (this.currentVariantId) {
          this.specificationsCache.set(this.currentVariantId, this.readSpecificationValues(this));
        }
        const signal = this.controller.signal;
        const syncFromProductForm = () => {
          const productInfo = this.primaryProductInfo();
          const input = productInfo && productInfo.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input) this.updateSpecifications(input.value);
        };

        document.addEventListener('change', event => {
          const input = event.target;
          if (!input || !input.matches ||
              !input.matches('input[name="id"], select[name="id"]')) return;
          const productInfo = this.primaryProductInfo();
          if (!productInfo || input.closest('product-info') !== productInfo) return;
          const form = input.closest('form');
          if (!form || !form.action.includes('/cart/add')) return;
          this.updateSpecifications(input.value);
        }, { signal });
        document.addEventListener('product-info:loaded', syncFromProductForm, { signal });
        syncFromProductForm();
      }

      primaryProductInfo() {
        const productId = this.dataset.productId;
        return Array.from(document.querySelectorAll('product-info'))
          .find(productInfo => productInfo.dataset.productId === productId &&
            !productInfo.closest('quick-add-modal'));
      }

      readSpecificationValues(root) {
        return new Map(Array.from(root.querySelectorAll('[data-hpt-variant-field]'))
          .map(row => [row.dataset.hptVariantField, row.querySelector('dd').innerHTML]));
      }

      applySpecificationValues(values, variantId) {
        this.specificationRows.forEach(row => {
          const value = values.get(row.dataset.hptVariantField);
          if (value !== undefined) row.querySelector('dd').innerHTML = value;
        });
        this.currentVariantId = variantId;
        this.dataset.variantId = variantId;
      }

      setSpecificationsBusy(busy) {
        this.specificationRows.forEach(row => {
          const list = row.closest('.hptb-details');
          if (!list) return;
          if (busy) list.setAttribute('aria-busy', 'true');
          else list.removeAttribute('aria-busy');
        });
      }

      clearSpecificationValues() {
        this.specificationRows.forEach(row => {
          row.querySelector('dd').textContent = '—';
        });
      }

      async updateSpecifications(value) {
        const variantId = String(value || '');
        if (!/^\d+$/.test(variantId)) {
          if (this.specificationsController) this.specificationsController.abort();
          this.requestedVariantId = '';
          this.currentVariantId = '';
          this.dataset.variantId = '';
          this.clearSpecificationValues();
          this.setSpecificationsBusy(false);
          return;
        }
        if (variantId === this.requestedVariantId ||
            (variantId === this.currentVariantId && !this.requestedVariantId)) return;
        if (this.specificationsController) this.specificationsController.abort();
        this.requestedVariantId = variantId;
        const cached = this.specificationsCache.get(variantId);
        if (cached) {
          this.applySpecificationValues(cached, variantId);
          this.requestedVariantId = '';
          this.setSpecificationsBusy(false);
          return;
        }

        const request = new AbortController();
        this.specificationsController = request;
        this.clearSpecificationValues();
        this.setSpecificationsBusy(true);
        try {
          const url = new URL(this.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', variantId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {
            signal: request.signal,
            credentials: 'same-origin',
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) throw new Error('Product specifications could not be loaded');
          const html = await response.text();
          if (request.signal.aborted || !this.isConnected ||
              this.requestedVariantId !== variantId) return;
          const document = new DOMParser().parseFromString(html, 'text/html');
          const section = document.getElementById(this.id);
          if (!section || section.dataset.variantId !== variantId) {
            throw new Error('Product specifications did not match the selected variant');
          }
          const values = this.readSpecificationValues(section);
          if (this.specificationRows.some(row => !values.has(row.dataset.hptVariantField))) {
            throw new Error('Product specifications were incomplete');
          }
          this.specificationsCache.set(variantId, values);
          if (this.specificationsCache.size > 20) {
            this.specificationsCache.delete(this.specificationsCache.keys().next().value);
          }
          this.applySpecificationValues(values, variantId);
        } catch (error) {
          if (error.name !== 'AbortError' && this.requestedVariantId === variantId) {
            this.currentVariantId = '';
            this.dataset.variantId = '';
          }
        } finally {
          if (this.requestedVariantId === variantId) {
            this.requestedVariantId = '';
            this.setSpecificationsBusy(false);
          }
        }
      }

      updateMode() {
        const next = this.media.matches && this.dataset.mobileLayout !== 'tabs'
          ? 'accordion' : 'tabs';
        if (next === this.mode) return;
        this.mode = next;
        this.classList.toggle('hptb--accordion', next === 'accordion');
        this.classList.toggle('hptb--tabs', next === 'tabs');

        if (next === 'accordion') {
          if (!this.accordionKeys) {
            const initial = this.dataset.mobileInitial || 'none';
            this.accordionKeys = new Set(
              this.tabs.filter(tab => tab.dataset.tabKey === initial)
                .map(tab => tab.dataset.blockId)
            );
          }
          this.tablist.removeAttribute('role');
          this.tablist.removeAttribute('aria-label');
          this.tabs.forEach((tab, index) => {
            tab.removeAttribute('role');
            tab.removeAttribute('aria-controls');
            tab.removeAttribute('aria-selected');
            tab.removeAttribute('tabindex');
            this.panels[index].hidden = false;
            this.panels[index].setAttribute('role', 'region');
            this.panels[index].setAttribute('aria-labelledby', this.headings[index].id);
            this.panels[index].removeAttribute('tabindex');
            this.items[index].open = this.accordionKeys.has(tab.dataset.blockId);
          });
          return;
        }

        this.tablist.setAttribute('role', 'tablist');
        this.tablist.setAttribute('aria-label',
          this.tabs.map(tab => tab.textContent.trim()).join(' / '));
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
        });
        const preferred = this.dataset.activeTab || this.dataset.defaultTab;
        const initial = this.tabs.findIndex(tab => tab.dataset.tabKey === preferred);
        this.activate(initial < 0 ? 0 : initial, false);
      }

      rememberAccordion() {
        this.accordionKeys = new Set(
          this.items.filter(item => item.open).map(item => item.dataset.blockId)
        );
      }

      activate(index, moveFocus) {
        if (!this.tabs || !this.tabs[index]) return;
        if (this.mode === 'accordion') {
          this.items.forEach((item, current) => {
            if (current === index) {
              item.open = true;
            } else if (this.dataset.mobileSingleOpen === 'true') {
              item.open = false;
            }
          });
          this.dataset.activeTab = this.tabs[index].dataset.tabKey;
          this.rememberAccordion();
          if (moveFocus) this.headings[index].focus({ preventScroll: true });
          return;
        }

        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
          this.items[current].open = selected;
        });
        this.dataset.activeTab = this.tabs[index].dataset.tabKey;
        if (moveFocus) this.tabs[index].focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
